<template>
    <div class="Dev">
        <div class="Dev-container" v-if="this.$store.state.showDebug">
            <ul class="Dev-list">
                <li :index="index"
                        :key="index"
                        :param="param"
                        v-for="(param, index) in articleParams">{{index}}: <b>{{param}}</b></li>
            </ul>
        </div>
    </div>
</template>

<script>
    //const _ = require('lodash');

    export default {
        name: 'debugArticleDisplay',
        props: ['article'],
        computed: {
            articleParams() {
                return {
                    //'bj': this.article.bj+1,
                    'Step': this.article.step + 1,
                    'Privacy': (this.article.isPublic) ? 'Public' : 'Private',
                    'Order': this.article.order + 1,
                    'Slug': this.article.slug
                    //'Total Articles': _.flatten(this.$store.state.articlesFullList).length
                };
            }
        }
    };
</script>

<style lang="scss">
    .Dev {
        position: relative;

        &-container {
            color: rgba(128, 128, 160, 1);
            font-size: .8rem;
            line-height: .8rem;
            margin: 10px;
            padding: 5px 10px;
            border: 1px solid rgba(0, 0, 0, .9);
            background-color: rgba(0, 0, 0, .8);
            border-radius: 5px;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
        }

        &-list {
            padding-left: .8rem;

            b {
                color: lighten(rgba(128, 128, 160, 1), 30);
            }
        }
    }
</style>
